export default "__VITE_ASSET__DSEZ8nlL__"